import Container from "react-bootstrap/Container";
import FormSection from "../components/formsection";
import Button from "react-bootstrap/Button";
import { Row, Col, Card, Form } from "react-bootstrap";
import Faq from "../components/Faq";
import "../styles/dualEducation.css";
import "../styles/sliderCalculator.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";

const MORTGAGE_RATES = { fix: 6.45, valt: 7.35 };

function annuityPayment(principal, annualRatePct, months) {
  const r = annualRatePct / 100 / 12;
  if (r === 0) return principal / months;
  return (principal * r) / (1 - Math.pow(1 + r, -months));
}

export default function Jelzaloghitel() {
  const [property, setProperty] = useState(45); // millió Ft
  const [amount, setAmount] = useState(30); // millió Ft
  const [term, setTerm] = useState(20); // év
  const [rateType, setRateType] = useState("fix");

  const handlePropertyChange = (value) => {
    setProperty(value);
    if (amount > value) setAmount(value);
  };

  const handleAmountChange = (value) => {
    setAmount(Math.min(value, property));
  };

  const ltv = (amount / property) * 100;
  const rate = MORTGAGE_RATES[rateType];
  const monthlyRepayment = annuityPayment(amount * 1_000_000, rate, term * 12);

  const eligibility =
    ltv <= 80
      ? {
          status: "ok",
          text: `Az LTV ${ltv.toFixed(
            0
          )}%, ez jellemzően megfelel az Otthon Start és a legtöbb piaci jelzáloghitel 80%-os LTV-korlátjának is.`,
        }
      : ltv <= 90
      ? {
          status: "warn",
          text: `Az LTV ${ltv.toFixed(
            0
          )}%, ez meghaladja a 80%-os általános korlátot — magasabb önerő vagy kiegészítő fedezet (pl. állami kezesség) szükséges lehet a jóváhagyáshoz.`,
        }
      : {
          status: "bad",
          text: `Az LTV ${ltv.toFixed(
            0
          )}%, ez a legtöbb hazai jelzáloghitel-terméknél túl magas — érdemes az önerőt növelni, vagy alacsonyabb hitelösszeggel újraszámolni.`,
        };

  return (
    <>
      <Container className="px-1 hero mx-md-auto">
        <span className="badge">JELZÁLOGHITEL • ÖSSZEHASONLÍTÁS • 2026</span>

        <h1 className="title">
          Jelzáloghitel <br />
          <span style={{ color: "#c7d2fe" }}>összehasonlítás és kalkulátor</span>
        </h1>

        <p className="subtitle">
          A jelzáloghitel ingatlanvásárlásra vagy -építésre felvett, fedezetül
          szolgáló ingatlannal biztosított kölcsön, amelynek THM-je 2026-ban
          fix kamatozás esetén jellemzően 6-8%, változó kamatozásnál 7-9,5%
          között alakul, a hitelfedezeti aránytól (LTV) és a futamidőtől
          függően.
          <br />
          <span className="fw-bold">
            Nézd meg a jogosultságod, és számold ki az illusztratív havi
            törlesztőt!
          </span>
        </p>

        <div className="cta">
          <Button href="#calculation" className="btn btn-primary">
            Kalkulátor
          </Button>

          <Button href="#leadform" className="btn btn-secondary">
            Ajánlatot kérek
          </Button>
        </div>
      </Container>

      <Container>
        <section className="section">
          <Row className="g-4">
            <Col md={4}>
              <Card className="card">
                <div className="kpi">6-8%</div>
                <div className="muted">Illusztratív THM fix kamatozásnál</div>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="card">
                <div className="kpi">7-9,5%</div>
                <div className="muted">Illusztratív THM változó kamatozásnál</div>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="card">
                <div className="kpi">80%</div>
                <div className="muted">Max. hitelfedezeti arány (LTV)</div>
              </Card>
            </Col>
          </Row>
        </section>

        <section id="jogosultsag" className="section">
          <h2 className="h2">Jogosult vagy-e kedvezményes jelzáloghitelre?</h2>
          <p className="lead">
            Az Otthon Start Program és a legtöbb piaci jelzáloghitel
            legfeljebb 80%-os hitelfedezeti arány (LTV) mellett nyújt
            kedvezményes kamatot; e fölött csak magasabb önerővel vagy
            kiegészítő fedezettel érhető el finanszírozás.
          </p>
        </section>

        <Container id="calculation">
          <h2 className="h2 mt-5">Jelzáloghitel kalkulátor</h2>
          <section className="slider-calculator section p-0">
            <div className="calculator-wrapper">
              <h3 className="h4">
                Ingatlan értéke: <span className="number">{property}</span>{" "}
                millió Ft
              </h3>
              <input
                type="range"
                min={10}
                max={150}
                step={1}
                value={property}
                onChange={(e) => handlePropertyChange(Number(e.target.value))}
                className="slider"
              />

              <h3 className="h4 mt-4">
                Igényelt hitelösszeg: <span className="number">{amount}</span>{" "}
                millió Ft
              </h3>
              <input
                type="range"
                min={5}
                max={150}
                step={1}
                value={amount}
                onChange={(e) => handleAmountChange(Number(e.target.value))}
                className="slider"
              />

              <h3 className="h4 mt-4">
                Futamidő: <span className="number">{term}</span> év
              </h3>
              <input
                type="range"
                min={5}
                max={35}
                step={1}
                value={term}
                onChange={(e) => setTerm(Number(e.target.value))}
                className="slider"
              />

              <div className="d-flex gap-4 mt-3">
                <Form.Check
                  type="radio"
                  id="rate-fix"
                  name="rate-type"
                  label="Fix kamatozású"
                  checked={rateType === "fix"}
                  onChange={() => setRateType("fix")}
                />
                <Form.Check
                  type="radio"
                  id="rate-valt"
                  name="rate-type"
                  label="Változó kamatozású"
                  checked={rateType === "valt"}
                  onChange={() => setRateType("valt")}
                />
              </div>

              <div
                className="disclaimer mt-3"
                style={{
                  padding: "16px",
                  borderRadius: "12px",
                  background:
                    eligibility.status === "ok"
                      ? "rgba(16, 185, 129, 0.1)"
                      : eligibility.status === "warn"
                      ? "rgba(251, 191, 36, 0.1)"
                      : "rgba(239, 68, 68, 0.1)",
                }}
              >
                <strong>LTV: {ltv.toFixed(0)}%</strong> — {eligibility.text}
              </div>

              <div className="revenue-block">
                <div className="row">
                  <Col md={12}>
                    <div className="revenue-text">
                      Becsült havi törlesztőrészlet*:
                    </div>
                    <div className="revenue-value">
                      <strong>
                        {Math.round(monthlyRepayment).toLocaleString()} Ft / hó
                      </strong>
                    </div>
                  </Col>
                </div>
                <div className="disclaimer mt-3">
                  *Illusztratív becslés, {rateType === "fix" ? "6,45" : "7,35"}
                  %-os illusztratív kamattal számolva, ami nem konkrét banki
                  ajánlat. A valós kamat és THM bankonként, futamidőnként és
                  ügyfélprofilonként eltérhet.
                </div>
              </div>
            </div>
            <div className="text-center mt-5">
              <Button href="#leadform" className="btn btn-primary">
                Pontos ajánlatot kérek
              </Button>
            </div>
          </section>
        </Container>

        <section id="folyamat" className="section">
          <h2 className="h2">Így működik a jelzáloghitel igénylése</h2>
          <div className="steps-container mt-4">
            <Row className="g-4">
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">1</div>
                <p className="fw-bold">Adatok megadása</p>
                <p className="small">
                  Ingatlanérték, igényelt összeg, futamidő és kamattípus
                </p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">2</div>
                <p className="fw-bold">Jogosultság ellenőrzése</p>
                <p className="small">
                  Azonnal látod az LTV-t és a becsült havi törlesztőt
                </p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">3</div>
                <p className="fw-bold">Ajánlatkérés</p>
                <p className="small">
                  Elérhetőséged megadása, továbbítjuk a kiválasztott
                  bankoknak
                </p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">4</div>
                <p className="fw-bold">Döntés és szerződés</p>
                <p className="small">
                  A beérkező ajánlatok közül te döntesz, kötelezettség nélkül
                </p>
              </Col>
            </Row>
          </div>
        </section>

        <Container id="leadform">
          <h2 className="h2">Kérjen ajánlatot még ma!</h2>
          <p className="lead small">
            Add meg az adataid, és 24 órán belül visszajelzünk a jelzáloghitel
            lehetőségeidről!
          </p>
          <Row>
            <Col md={4}>
              <FormSection formType="Jelzáloghitel" />
            </Col>
            <Col md={7} className="ms-md-5 ps-md-5 pt-2">
              <ul className="list check-list mt-3">
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Díjmentes tanácsadás</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Több bank ajánlata egy helyen</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Segítség az Otthon Start jogosultság ellenőrzésében</h4>
                </li>
                <li className="mb-3">
                  <FontAwesomeIcon
                    icon={faCheck}
                    className="mb-2"
                    style={{ fontSize: "20px" }}
                  />
                  <h4>Bankfüggetlen, versenyeztetett ajánlatok</h4>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>

        <section id="faq" className="section pb-0">
          <h2 className="h2">Gyakran ismételt kérdések</h2>

          <Faq
            categories={[
              {
                key: "altalanos",
                label: "Általános",
                items: [
                  {
                    question:
                      "Mekkora önerő kell jelzáloghitelhez 2026-ban?",
                    answer:
                      "A legtöbb banknál minimum 20% önerő szükséges, vagyis az ingatlan értékének legfeljebb 80%-áig (LTV) nyújtanak hitelt. Az Otthon Start Program is ehhez a 80%-os korláthoz igazodik, tehát 20%-nál kevesebb önerővel jellemzően magasabb kamatfelárral vagy kiegészítő fedezettel lehet csak finanszírozáshoz jutni.",
                  },
                  {
                    question:
                      "Mi a különbség a fix és változó kamatozású jelzáloghitel között?",
                    answer:
                      "A fix kamatozású hitelnél a törlesztő a teljes (vagy egy hosszabb periódus) futamidő alatt nem változik, kiszámítható, de a kiinduló THM jellemzően magasabb. A változó kamatozású hitel induló THM-je alacsonyabb lehet, de a törlesztő a piaci kamatok (pl. BUBOR) mozgásával együtt változhat, ami kockázatot jelent.",
                  },
                  {
                    question:
                      "Kombinálható-e az Otthon Start Program más lakástámogatással?",
                    answer:
                      "Az Otthon Start Program egyes elemei más állami lakástámogatási formákkal is összevonhatók lehetnek, de a pontos kombinálhatóság konstrukciónként és banki elbírálás szerint eltér. Mindig kérj konkrét, aktuális tájékoztatást a választott banktól vagy hivatalos állami forrásból a kombinálás pontos feltételeiről.",
                  },
                  {
                    question:
                      "Mennyi a jelzáloghitel THM-je egy 30 milliós hitelnél?",
                    answer:
                      "Egy 30 millió forintos, 20 éves futamidejű jelzáloghitelnél 2026-ban a fix kamatozású THM jellemzően 6-8%, a változó kamatozású THM 7-9,5% között mozog, az LTV-től, a bank önköltségi szerkezetétől és az ügyfél kockázati besorolásától függően.",
                  },
                  {
                    question:
                      "Hogyan válthatok bankot meglévő jelzáloghitellel (kiváltás)?",
                    answer:
                      "Hitelkiváltásnál az új bank kifizeti a régi hitel fennálló tartozását, te pedig az új, jellemzően kedvezőbb THM-mel rendelkező konstrukció szerint törlesztesz tovább. A folyamat új hitelbírálattal, értékbecsléssel és a régi jelzálogjog törlésével jár, ezért 4-8 hetet érdemes rá számolni.",
                  },
                ],
              },
            ]}
          />

          <p className="small mt-4">
            A fenti kalkulátor illusztratív becslést ad, nem minősül
            hitelbírálatnak vagy ajánlattételnek. A Financials.hu nem
            hitelintézet; a végleges kondíciókat a kiválasztott bank
            hitelbírálata és értékbecslése határozza meg. Az oldalon
            feltüntetett THM-tartományok forrása a bankok hivatalos
            hirdetménye és az MNB nyilvános adatbázisa.
          </p>
        </section>
      </Container>
    </>
  );
}
